// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-scoreMoney-wrapper .payment-scoreMoney-content {
  gap: var(--spacing-small);
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay {
  gap: var(--spacing-small);
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .vert-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
  flex: 1;
  min-width: 40%;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .ant-input-number {
  width: 100%;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .ant-input-number-input {
  text-align: center;
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .ant-btn {
  width: 100%;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .ant-checkbox:hover .ant-checkbox-inner {
  border-color: var(--color-detached) !important;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .ant-checkbox .ant-checkbox-wrapper-checked .ant-checkbox-inner {
  border-color: var(--color-detached) !important;
  background-color: var(--color-detached) !important;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .vert-input.ant-input-affix-wrapper-disabled,
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .vert-input.ant-input-disabled {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay .payment-scoreMoney-inputBold[disabled] {
  background-color: var(--bg-color-disabled-input) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-input-disabled) !important;
}
.payment-scoreMoney-wrapper .payment-scoreMoney-content .vert-check.ant-checkbox-wrapper {
  font-size: 12px;
}
@media screen and (max-width: 768px) {
  .payment-scoreMoney-wrapper .payment-scoreMoney-content {
    display: grid;
  }
  .payment-scoreMoney-wrapper .payment-scoreMoney-content .payment-scoreMoney-amountToPay {
    gap: var(--spacing-small);
    display: flex;
    flex-direction: column;
  }
}
/* TooltipStyles.css */
.payment-typograph {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-extra-small);
}
.payment-tooltip-small .ant-tooltip-inner {
  width: 388px !important;
  height: 56px !important;
  font-family: var(--font-family) !important;
  font-size: var(--font-regular) !important;
}
.payment-tooltip-medium .ant-tooltip-inner {
  width: 425px !important;
  height: 76px !important;
  font-family: var(--font-family) !important;
  font-size: var(--font-regular) !important;
}
.payment-tooltip-large .ant-tooltip-inner {
  width: 425px !important;
  height: 95px !important;
  font-family: var(--font-family) !important;
  font-size: var(--font-regular) !important;
}
@media (max-width: 768px) {
  .payment-tooltip-small .ant-tooltip-inner {
    width: 240px !important;
    /* Reduzido de 250px */
    height: 65px !important;
    font-size: var(--font-small) !important;
    /* Ajuste o tamanho da fonte se necessário */
  }
  .payment-tooltip-medium .ant-tooltip-inner {
    width: 260px !important;
    /* Reduzido de 300px */
    height: 90px !important;
    font-size: var(--font-small) !important;
    /* Ajuste o tamanho da fonte se necessário */
  }
}
.card-brand-accept {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  flex-wrap: wrap;
  margin-bottom: var(--spacing-extra-small);
}
.card-brand-box {
  border-radius: calc(var(--border-radius-primary) / 2);
  height: 32px;
  width: 46.667px;
  border: 1px solid var(--color-neutral-light);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/PaymentScoreMoreMoneyStyles.less"],"names":[],"mappings":"AAAA;EAEI,yBAAA;AAAJ;AAFA;EAIM,yBAAA;AACN;AALA;EAMQ,0BAAA;EACA,2BAAA;EACA,OAAA;EACA,cAAA;AAER;AAXA;EAaQ,WAAA;AACR;AAdA;EAgBQ,kBAAA;EACA,gBAAA;EACA,gCAAA;AACR;AAnBA;EAqBQ,WAAA;AACR;AAGQ;EAEI,8CAAA;AAFZ;AAzBA;EAgCY,8CAAA;EACA,kDAAA;AAJZ;AA7BA;;EAwCI,2DAAA;EACA,4CAAA;EACA,kDAAA;AAPJ;AAWE;EACE,2DAAA;EACA,4CAAA;EACA,kDAAA;AATJ;AAxCA;EA2DM,eAAA;AAhBN;AAqBA;EACE;IAEI,aAAA;EApBJ;EAkBA;IAIM,yBAAA;IACA,aAAA;IACA,sBAAA;EAnBN;AACF;AACA,sBAAsB;AAwBtB;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AAtBF;AAwBA;EACE,uBAAA;EACA,uBAAA;EACA,0CAAA;EACA,yCAAA;AAtBF;AAwBA;EACE,uBAAA;EACA,uBAAA;EACA,0CAAA;EACA,yCAAA;AAtBF;AAwBA;EACE,uBAAA;EACA,uBAAA;EACA,0CAAA;EACA,yCAAA;AAtBF;AA2BA;EACE;IACE,uBAAA;IAzBA,sBAAsB;IA0BtB,uBAAA;IACA,uCAAA;IAxBA,4CAA4C;EAC9C;EA2BA;IACE,uBAAA;IAzBA,sBAAsB;IA0BtB,uBAAA;IACA,uCAAA;IAxBA,4CAA4C;EAC9C;AACF;AA4BA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,yCAAA;AA1BF;AA4BA;EACE,qDAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA1BF","sourcesContent":[".payment-scoreMoney-wrapper {\n  .payment-scoreMoney-content {\n    gap: var(--spacing-small);\n    .payment-scoreMoney-amountToPay {\n      gap: var(--spacing-small);\n      .vert-col {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n        flex: 1;\n        min-width: 40%;\n      }\n\n      .ant-input-number {\n        width: 100%;\n      }\n      .ant-input-number-input {\n        text-align: center;\n        font-weight: 600;\n        color: var(--color-neutral-dark);\n      }\n      .ant-btn {\n        width: 100%;\n      }\n\n      .ant-checkbox {\n        &:hover {\n          .ant-checkbox-inner {\n            border-color: var(--color-detached) !important;\n          }\n        }\n        .ant-checkbox-wrapper-checked {\n          .ant-checkbox-inner {\n            border-color: var(--color-detached) !important;\n            background-color: var(--color-detached) !important;\n          }\n        }\n      }\n\n\n  .vert-input.ant-input-affix-wrapper-disabled, .vert-input.ant-input-disabled {\n    background-color: var(--bg-color-disabled-input) !important;\n    border-color: var(--color-border) !important;\n    color: var(--color-text-input-disabled) !important;\n  }\n\n.payment-scoreMoney-inputBold {\n  &[disabled] {\n    background-color: var(--bg-color-disabled-input) !important;\n    border-color: var(--color-border) !important;\n    color: var(--color-text-input-disabled) !important;\n  }\n}\n\n\n\n\n    }\n\n    .vert-check.ant-checkbox-wrapper {\n      font-size: 12px;\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .payment-scoreMoney-wrapper {\n    .payment-scoreMoney-content {\n      display: grid;\n      .payment-scoreMoney-amountToPay {\n        gap: var(--spacing-small);\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n}\n\n/* TooltipStyles.css */\n.payment-typograph {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-small);\n  margin-bottom: var(--spacing-extra-small);\n}\n.payment-tooltip-small .ant-tooltip-inner {\n  width: 388px !important;\n  height: 56px !important;\n  font-family: var(--font-family) !important;\n  font-size: var(--font-regular) !important;\n}\n.payment-tooltip-medium .ant-tooltip-inner {\n  width: 425px !important;\n  height: 76px !important;\n  font-family: var(--font-family) !important;\n  font-size: var(--font-regular) !important;\n}\n.payment-tooltip-large .ant-tooltip-inner {\n  width: 425px !important;\n  height: 95px !important;\n  font-family: var(--font-family) !important;\n  font-size: var(--font-regular) !important;\n}\n\n\n\n@media (max-width: 768px) {\n  .payment-tooltip-small .ant-tooltip-inner {\n    width: 240px !important; /* Reduzido de 250px */\n    height: 65px !important;\n    font-size: var(\n      --font-small\n    ) !important; /* Ajuste o tamanho da fonte se necessário */\n  }\n  .payment-tooltip-medium .ant-tooltip-inner {\n    width: 260px !important; /* Reduzido de 300px */\n    height: 90px !important;\n    font-size: var(\n      --font-small\n    ) !important; /* Ajuste o tamanho da fonte se necessário */\n  }\n}\n\n.card-brand-accept {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-small);\n  flex-wrap: wrap;\n  margin-bottom: var(--spacing-extra-small);\n}\n.card-brand-box {\n  border-radius: calc(var(--border-radius-primary) / 2);\n  height: 32px;\n  width: 46.667px;\n  border: 1px solid var(--color-neutral-light);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
